import React from "react"
import DateTimeField from "components/Common/DateTimeField"
import Select from "react-select"
import { ORGANIZER_SORT_OPTIONS } from "./listQuery"
import { withFloatingSurface } from "components/Common/selectSurface"

const statusOptions = [
  { label: "Activated", value: "activated" },
  { label: "Pending", value: "pending" },
  { label: "Blocked", value: "blocked" },
  { label: "Deleted", value: "deleted" },
]

const FilterList = ({
  filters, onChange, locations, advancedFilters, sortBy, onSort,
  locationsLoading, dateError,
}) => {
  const locationOptions = locations.map(location => ({
    label: location.city ? `${location.city}, ${location.country} (${location.total})` : `${location.country} — all cities (${location.total})`,
    value: `${location.city ?? "null"}, ${location.country}`,
  }))
  const accountTypes = [{ label: "Player", value: "player" }, { label: "Club", value: "club" }]
  const selectField = (key, label, options) => (
    <div className="club-filter-field">
      <label htmlFor={`organizer-${key}`}>{label}</label>
      <Select styles={withFloatingSurface()} inputId={`organizer-${key}`} instanceId={`organizer-${key}`}
        name={key} options={options} placeholder="All" isClearable
        classNamePrefix="club-filter-select"
        isLoading={key === "location" && locationsLoading}
        value={options.find(option => option.value === filters[key]) ||
          (filters[key] ? { value: filters[key], label: filters[key].replace(/^null, /, "") } : null)}
        onChange={option => onChange({ [key]: option?.value || "" })}
      />
    </div>
  )
  return (
    <>
      <div className="club-filters-primary">
        {selectField("location", "Organizer location", locationOptions)}
        {selectField("accountType", "Account type", accountTypes)}
        {selectField("status", "Status", statusOptions)}
        <div className="club-filter-field">
          <label htmlFor="organizer-sort">Sort organizers</label>
          <select id="organizer-sort" className="custom-select" value={sortBy}
            onChange={event => onSort(event.target.value)}>
            {ORGANIZER_SORT_OPTIONS.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
          </select>
        </div>
      </div>
      {advancedFilters && (
        <div id="organizer-date-filters" className="club-filters-secondary">
          {[["fromDate", "Account created from"], ["toDate", "Account created to"]].map(([key, label]) => (
            <div className="club-filter-field" key={key}>
              <label htmlFor={`organizer-${key}`}>{label}</label>
              <DateTimeField id={`organizer-${key}`} name={key} mode="date"
                {...(key === "fromDate" ? { rangeEnd: filters.toDate || "" } : { rangeStart: filters.fromDate || "" })}
                value={filters[key] || ""} aria-invalid={Boolean(dateError)}
                aria-describedby={dateError ? "organizer-date-error" : "organizer-timezone"}
                onChange={event => onChange({ [key]: event.target.value })} />
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default FilterList
